import React from "react";
import { useParams, Navigate } from "react-router-dom";
import { regionDetails } from "@/content/site";
import { PageHero, Section, CtaBand } from "@/components/NovaKit";

export default function Region() {
  const { slug } = useParams();
  const r = regionDetails[slug];
  if (!r) return <Navigate to="/" replace />;

  return (
    <div data-testid={`region-${slug}-page`}>
      <PageHero eyebrow={`Regions / ${r.name}`} heading={r.name} highlight={r.name.replace(" Operations", "")} intro={r.subtitle} index="13" />

      <Section indexLabel="13.0" bg="panel">
        <p className="text-base md:text-xl leading-[1.6] text-[#0A0E1A]/85 max-w-4xl border-l-4 border-[#4F46E5] pl-6">
          {r.intro}
        </p>
      </Section>

      <Section eyebrow={r.whyHeading} heading={r.whyHeading} highlight="market matters" indexLabel="13.1">
        <p className="text-base md:text-lg leading-[1.7] text-[#0A0E1A]/80 max-w-4xl">{r.whyBody}</p>
      </Section>

      <Section eyebrow={r.easierHeading} heading="The operational payoff in this market" highlight="operational payoff" indexLabel="13.2" bg="panel">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {r.easier.map((item, i) => (
            <div key={item} className="grad-border grad-border-on card-hover bg-white rounded-[20px] p-6 md:p-8 flex items-start gap-4">
              <span className="mono text-[11px] tracking-[0.22em] uppercase grad-text font-bold mt-1">{String(i + 1).padStart(2, "0")}</span>
              <p className="text-base leading-relaxed text-[#0A0E1A]/85 flex-1">{item}</p>
            </div>
          ))}
        </div>
      </Section>

      <CtaBand heading={r.finalCta} ctas={r.ctas} />
    </div>
  );
}
